import Vue from 'vue'
import router from '@/router'
import { UserLogin, UserLogout, UserTokenLogin, yiwuTokenLogin } from '@/services/login'
import { handleError } from '@/utils/util'

const state = {
  loginModalVisible: false
}

const mutations = {
  toggleLoginModalVisible(state) {
    const { loginModalVisible } = state
    if (loginModalVisible) {
      state.loginModalVisible = false
    } else {
      state.loginModalVisible = true
    }
  }
}

const actions = {
  async login({ commit }, payload) {
    const response = await UserLogin(payload)
    if (response && response.code === '0') {
      const { accessToken, refreshToken } = response.data
      window.localStorage.setItem('access-token', accessToken)
      window.localStorage.setItem('refreshToken', refreshToken)
      window.localStorage.setItem('userInfoApp', JSON.stringify(response.data))
      Vue.prototype.$message.success('登录成功')

      const lastTownId = localStorage.getItem('lastTownId')

      if (lastTownId) {
        commit('user/updateTownId', lastTownId, { root: true })
      }

      commit({ type: 'toggleLoginModalVisible' })
      commit('user/updateUserInfo', response.data, { root: true })
    } else {
      handleError(response)
    }
  },
  async loginByToken({ commit }, payload) {
    const response = await UserTokenLogin(payload)
    if (response && response.code === '0') {
      const { accessToken, refreshToken } = response.data
      window.localStorage.setItem('access-token', accessToken)
      window.localStorage.setItem('refreshToken', refreshToken)
      window.localStorage.setItem('userInfoApp', JSON.stringify(response.data))
      window.localStorage.setItem('lastTownId', response.data.townId)

      Vue.prototype.$message.success('登录成功')

      const lastTownId = localStorage.getItem('lastTownId')

      if (lastTownId) {
        commit('user/updateTownId', lastTownId, { root: true })
      }

      // commit({ type: 'toggleLoginModalVisible' })
      commit('user/updateUserInfo', response.data, { root: true })
    } else {
      handleError(response)
    }
  },
  async yiwuTokenLogin({ commit }, payload) {
    const response = await yiwuTokenLogin(payload)
    return new Promise((resolve) => {
      resolve(response)
    })
  },
  async logout({ commit }, payload) {
    const response = await UserLogout()
    if (response && response.code === '0') {
      window.localStorage.clear()

      commit('user/updateUserInfo', null, { root: true })
      commit('user/updateTownId', null, { root: true })
      if (payload) {
        if (payload.taihzou) {
          router.push('/yiwu')
        } else if (payload.huangyan) {
          router.push('/huangyan')
        } else if (payload.haishu) {
          router.push('/haishu')
        } else {
          router.push('/')
        }
      } else {
        router.push('/')
      }
    } else {
      handleError(response)
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/login.js